
<template>
    <div class=" text-nowrap">
        <a :href="link?link:'#'" class="avatar avatar-sm rounded-circle bg-cyan" >
                              {{ firstName?firstName.substring(0,1).toUpperCase():'' }}{{ lastName?lastName.substring(0,1).toUpperCase():''  }}
        </a>
        <span v-if="userId" class="ml-1 text-nowrap">#{{userId}}</span>
    </div>
</template>

<script>
 
  export default {
    name: 'user-icon',
    components: {
     
    },

    props:[
        'firstName',
        'lastName',
        'userId',
        'link'
    ],

    data() {
      return {
       
      };
    },
    computed:{
        
    },
    methods: {
       
    },

    watch:{
        
    }
  }
</script>

<style lang="scss" scoped>
  a {
    color: #fff !important;
  }
  a:hover {
    color: #fff !important;
  }
</style>
